import React from "react";

function Navbar() {
  return (
    <nav className="flex justify-center py-2 shadow-nav">
      <h1 className="font-semibold text-3xl text-slate-600">Star war People</h1>
    </nav>
  );
}

export default Navbar;
